import { remToPixels } from '../ui/functions.any';
export * from './functions.any';
/**
 * Fixes the style prop that is passed to a platform generic component based on platform specific
 * format requirements.
 *
 * @param {StyleType} style - The passed style prop to the component.
 * @returns {StyleType}
 */
export function getFixedPlatformStyle(style) {
    if (Array.isArray(style)) {
        const _style = {};
        for (const component of style) {
            Object.assign(_style, component);
        }
        return _style;
    }
    return style;
}
/**
 * Converts typography lineHeight from rem/em to pixels for 11sight compatibility.
 * This preserves 11sight's pixel-based line height approach.
 *
 * @param {Object} typography - The typography object with lineHeight property.
 * @returns {Object} Style object with lineHeight in pixels.
 */
export function withPixelLineHeight(typography) {
    if (!typography) {
        return {};
    }
    const result = { ...typography };
    if (typography.lineHeight) {
        if (typeof typography.lineHeight === 'string') {
            // Convert rem/em to pixels
            if (typography.lineHeight.includes('rem')) {
                result.lineHeight = `${remToPixels(typography.lineHeight)}px`;
            }
            else if (typography.lineHeight.includes('em')) {
                // For em, we need the font size to calculate properly
                const fontSize = typeof typography.fontSize === 'string'
                    ? parseFloat(typography.fontSize.replace('rem', '').replace('px', ''))
                    : (typography.fontSize || 16);
                const emValue = parseFloat(typography.lineHeight.replace('em', ''));
                result.lineHeight = `${Math.round(fontSize * emValue)}px`;
            }
            else if (!typography.lineHeight.includes('px')) {
                // If it's a number or unitless, assume it's already in pixels or needs conversion
                const numericValue = parseFloat(typography.lineHeight);
                if (!isNaN(numericValue)) {
                    result.lineHeight = `${Math.round(numericValue)}px`;
                }
            }
            // If already in px, keep it as is
        }
        else if (typeof typography.lineHeight === 'number') {
            // If it's a number, assume it's already in pixels
            result.lineHeight = `${typography.lineHeight}px`;
        }
    }
    return result;
}
